
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patio-design-app",
      function () {
        return require("private-next-pages/patio-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patio-design-app"])
      });
    }
  